<template>
<div>

    <h2>免责声明</h2>

    <div class="t">1、我们提供的产品和服务可能会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：</div>

    <div class="s">（1）其他用户可能会发布诈骗或虚假信息，或者发表含有谩骂、诅咒、诋毁、攻击内容的，或含有淫秽、色情、下流、发动、煽动民族仇恨等让人反感、厌恶的内容的非法言论；</div>
    <div class="s">（2）其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私或其他合法权益的图片、照片、文字等资料；</div>
    <div class="s">（3）面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。对于上述困扰，我们将尽可能地采取相应措施维护您的合法权益。</div>

    <div class="t n">2、您充分理解并同意：上述第1条款所述的各种不良信息、网络安全和网络故障问题，并不是我们所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，我们无须承担任何责任。 </div>
    <div class="t">3、您充分理解并同意：用户从事本协议第6.2条所述的第（1）—（5）项行为，是一种即时性的瞬间消失的行为，且会严重影响我们的产品和服务，因此，我们一经分析判断确认用户从事了该等行为，
        我们可能会立即采取诸如本协议第5.2 条所述的处理措施，对此，请给予充分的理解。 </div>

    <div class="t">4、您充分理解并同意：用户从本协议第6.2条所述的第（6）—（9）项行为，是一种即时性的瞬间即可让众多用户知晓的行为。如果不立即采取诸如本协议第5.2条所述的处理措施，可能会造成非常严重非常恶劣的后果。对此，您是给予充分理解的，并完全同意我们采取上述措施对上述行为进行处理。</div>

    <div class="t">5、您充分理解并同意：为了有效遏制用户使用BUG或外挂的行为，我们可能会采取停机维护或者回档的处理措施。停机维护期间，您可能会不能登陆烽行体育服务器。对此，您充分理解并愿意自行承担，我们将不给予任何赔偿。 </div>

    <div class="t">6、您充分理解并同意：我们的产品或服务可能会因为我们或者我们合作方的互联网系统软硬件设备的故障、失灵、或人为操作地疏失而全部或一部分中断、暂时无法使用、迟延，
        或因他人侵入系统篡改或伪造变造资料等，造成服务的停止或中断者或用户档案缺失，以及因相关政府机构要求的停止或中断，我们无须给予您或第三方任何的补偿或赔偿。</div>

    <div class="t">7、您充分理解并同意：“烽行擂台”赛中的榜单中，会展示包含但不限于账号头像、名称等。 </div>

    <div class="t">8、您同意使用我们的产品或服务是出于您个人意愿，并愿自行承担任何风险及由此给您造成的任何直接、间接、衍生的损害，我们不承担任何责任。若依法无法完全排除损害赔偿责任时，我们的赔偿责任亦以返还您就实施该等使用行为而支付给我们的价款为限。 </div>

    <div class="t c">9、烽行体育所有推荐皆由本网站合作签订的专家发布，本网站仅提供技术上的支持，对推荐的内容的正确性、完整性及品质不承担责任。因此：本站所有内容仅作为用户参考，不代表本站观点，更不表示我们支持用户使用，请您认真考虑后使用，因为使用不当所造成的损失我们不承担任何法律后果。对于经由烽行体育服务而传送的内容，本网站不保证您在接受有关服务时，有可能因专家发布的信息内容，有可能接触到令人不快、不适当或令人讨厌的内容。在任何情况下，本网站均不对任何内容负责。</div>

    <div class="t">10、烽行体育网站、APP可能刊登商业广告或其他活动促销的广告。这些内容系广告商或商品服务提供者所为，我们仅提供刊登内容的媒介。您通过我们或我们所链接的网站所购买的服务或商品，其交易行为仅存于您与该商品或服务的提供者之间，与本网站无关。</div>

    <div class="t">11、您可能在使用我们的产品和服务过程中链接到第三方的站点。第三方的站点不由我们控制，并且我们也不对任何第三方站点的内容、第三方站点包含的任何链接、或第三方站点的任何更改或更新负责。我们仅为了提供便利的目的而向您提供这些到第三方站点的链接，我们所提供的这些链接并不意味着我们认可该第三方站点。您需要检查并遵守该第三方站点的相关规定。 </div>

    <div class="t">12、您同意我们保留随时地、不事先通知地、不需要任何理由地、单方面的中止履行本协议及终止本协议的权利，您不会因此认为我们违反合同约定并承担法律责任。该等中止、终止，可能是因为服务公司解散、注销、合并、分立，也可能是因为国家法律、法规、政策及国家机关的命令或者其他的诸如地震、火灾、海啸、台风、罢工、战争等不可抗力事件，还可能是上列原因之外的其他原因。</div>

    <div class="t c">13、您充分理解到：已购的烽行体育产品（包含会员服务、结果为胜的预测产品）不予退还。</div>


</div>
</template>

<script>
    export default {
        name: "mianze_mini",
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
